import { CircularProgress } from "@material-ui/core";
import STForumLoadingPage from "../../assets/styles/atoms/forumLoadingPage.module.scss";

type ForumLoadingPageProps = {
  className?: string;
  size?: number;
};

const ForumLoadingPage = (props: ForumLoadingPageProps) => {
  const { className = "", size = 24 } = props ?? {};
  return (
    <div className={`${STForumLoadingPage.container} ${className}`}>
      <CircularProgress color="inherit" size={size} disableShrink />
    </div>
  );
};

export default ForumLoadingPage;
